import styled from 'styled-components';

export const Container = styled.div`
  background: #f9f9fb 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const ForgetPasswordBox = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #dfdfe6;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 8px;
  opacity: 1;
  padding: 20px;
`;

export const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const ImageContainer = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin: 20px 0 20px 0;
`;

export const TextTitle = styled.p`
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #2e384d;
  opacity: 1;
`;

export const SubText = styled.p`
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #2e384d;
  opacity: 1;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;
export const Label = styled.label`
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #2e384d;
  text-transform: uppercase;
  opacity: 1;
  margin-bottom: 4px;
`;
export const Input = styled.input`
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #dfe3e8;
  border-radius: 4px;
  opacity: 1;
  width: 335px;
  height: 45px;
  font-size: 14px;
  letter-spacing: 0px;
  color: #6b7786;
  opacity: 1;
  padding-left: 16px;
  margin-bottom: 20px;
`;

export const ButtonSendEmail = styled.button`
  width: 335px;
  height: 40px;
  border: 0.5px solid #2699fb;
  background: #2699fb;
  border-radius: 4px;
  opacity: 1;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #fff;
  text-transform: uppercase;
  opacity: 1;
`;

export const Backto = styled.a`
  margin-top: 8px;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0px;
  color: #2493eb;
  opacity: 1;
  cursor: pointer;
`;
